import { error, money } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const fetchVaroAdvanceProductV2 = gql`
  query VaroAdvanceProductsV2 {
    varoAdvanceProducts {
      __typename
      ... on VaroAdvanceProductsQualified {
        isFirstTime
        hasActiveAdvanceAccount
        options {
          id
          title
          description
          amount {
            ...money
          }
          fee {
            ...money
          }
        }
        repaymentDates {
          min
          max
          valid
          exclusions
          exclusionReason
          defaultDate
          dueDate
        }
      }
      ... on VaroAdvanceProductsNotQualified {
        addtionalInfo {
          copy
        }
        reason
        title
      }
      ... on VaroAdvanceProductsPendingEligibility {
        isPending
      }
      ... on VaroAdvanceProductsError {
        ...error
      }
    }
  }
  ${error}
  ${money}
`;

export default fetchVaroAdvanceProductV2;
